import { takeEvery, call, put, select, all } from 'redux-saga/effects';
import {
  initState as initRequestStatusState,
  requestInProcess,
  requestFinished,
  setCodeResponse
} from '../../../../common/reducers/_requestStatus/reducer';
import {
  initState as initStateFormErrors,
  setErrors,
  clearErrors
} from '../../../../common/reducers/_formErrors/reducer';
import { sendForm, initState, setResultObject } from './actions';
import { selectFormBody, selectFieldSum } from './selectors';
import { timeoutCall } from '../../../../utils/sagaHalper';
import PaymentsService from '../../services';
import { restructurePaymentModel } from '../../restructuring';
import { gtagEvent } from '../../../../utils/Analytics';

function* createPayment(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearErrors(reducerName));
    const response = yield call(timeoutCall, PaymentsService.createPayment, {
      ...formBody,
      ...{
        return_url: `https://${window.location.host}/board/main/my-balance/history`
      }
    });
    if (response) {
      if (response.status === 201) {
        const sumField = yield select(selectFieldSum, reducerName);
        gtagEvent({
          action: 'Старт оплаты пользователем',
          category: 'Попытка платежа',
          label: '',
          value: sumField.value
        });
        yield put(
          setResultObject(reducerName, restructurePaymentModel(response.data))
        );
      } else if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));
      }
      yield put(setCodeResponse(reducerName, response.status));
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName));
}

function* initStates(reducerName) {
  yield put(initRequestStatusState(reducerName));
  yield put(initStateFormErrors(reducerName));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(sendForm(reducerName).type, createPayment, reducerName),
    takeEvery(initState(reducerName).type, initStates, reducerName)
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/reducers/paymentForm/saga.js